export default "__VITE_ASSET__C1_DYSij__"